var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('MdmLink', {
    staticClass: "d-flex align-items-center",
    class: _vm.themeClass,
    attrs: {
      "url": _vm.url,
      "is-scramble-link": _vm.isScrambleLink,
      "is-prevent-default-link": _vm.isPreventDefaultLink
    }
  }, [_c('MdmIcon', {
    staticClass: "mr-2 svg flex-shrink-0",
    attrs: {
      "size": "24",
      "name": _vm.icon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column flex-grow-1"
  }, [_c('p', {
    staticClass: "m-0 label-main",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _vm.description ? _c('p', {
    staticClass: "m-0 label-secondary",
    domProps: {
      "textContent": _vm._s(_vm.description)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };